import React from "react";
import themePropTypes from "../theme-prop-types";

export const LAST_OF_KIND_CLASSNAME = "last-of-kind";

const ListItem = ({ children, onClick, childType, id, lastOfKind }) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events
  <div
    className={`list-item-web-sdk ${childType}-web-sdk ${
      lastOfKind ? LAST_OF_KIND_CLASSNAME : ""
    }`}
    data-testid={`list-item-${childType}-${id}`}
    tabIndex='-1'
    role='button'
    onClick={() => onClick()}
  >
    {children}
  </div>
);

ListItem.propTypes = themePropTypes.listItem;

export default ListItem;
